import { environment } from "@/environment/environment";
import { createClient } from "@supabase/supabase-js";

const { supabaseUrl: url } = environment
const { supabaseAnonKey: key } = environment

export const supabase = createClient(url, key);

/**
 * If you need to test the changepwd supabase => add redirect URLs localhost
 */
